import "../styles/add-person.scss";
import React, { useEffect, useState } from "react";
import PageLayout from "../components/page-layout";
import actions from "../actions/actions";
import api from "../api/api";
import { appState } from "../redux/redux-config";
import { useSelector } from "react-redux";
import { GuiButton } from "../components/global-ui/gui-button";
import { GuiTextbox } from "../components/global-ui/gui-textbox";
import { useUpdateState } from "../utilities/utilities";
import { GuiSelect } from "../components/global-ui/gui-select";
import { Icon } from "../components/icon";
import navigate from "../utilities/navigation";
import { Path, USStates } from "../utilities/constants";
import { v4 as uuidv4 } from "uuid";
import { showToast } from "../components/toast";
import { Modal } from "../components/modal";
import { FileUploadButton } from "../components/image-library-modal/file-upload";

export default function AddPersonPage() {
  let userTypeOptions =
    useSelector((store) => actions.user.loadUserTypes()) || [];
  const [isAddUserButtonDisabled, setIsAddUserButtonDisabled] = useState(false);

  let [state, updateState] = useUpdateState(() => {
    return {
      showConfirmAddUser: false,
    };
  });

  let [person, updatePerson] = useUpdateState({
    firstName: "",
    lastName: "",
    userType: "",
    contactMethods: [
      { id: uuidv4(), contactType: 4, phone: "", description: "" },
      { id: uuidv4(), contactType: 3, phone: "", ext: "", description: "" },
      { id: uuidv4(), contactType: 1, phone: "", ext: "", description: "" },
      { id: uuidv4(), contactType: 2, phone: "", ext: "", description: "" },
    ],
  });
  const [phoneErrorFlags, setPhoneErrorFlags] = useState([]);
  const [emailErrorFlags, setEmailErrorFlags] = useState([]);

  const handleEmailErrorChange = (index, hasError) => {
    setEmailErrorFlags((prev) => {
      const updated = [...prev];
      updated[index] = hasError;
      return updated;
    });
  };

  const handlePhoneErrorChange = (index, hasError) => {
    setPhoneErrorFlags((prev) => {
      const updated = [...prev];
      updated[index] = hasError;
      return updated;
    });
  };

  function validateForm() {
    person = {
      ...person,
      username: inputValue,
      uniqueEmail: inputEmailValue,
      password: inputPassword,
    };
    Object.entries(person).forEach(([key, value]) => {
      if (key === "password" && value === "") {
        setFieldErrors((prevErrors) => ({
          ...prevErrors,
          password: true,
        }));
      }
      if (value === "") {
        setFieldErrors((prevErrors) => ({
          ...prevErrors,
          [key]: true,
        }));
      }
    });
    // Ensure password is checked as required
    const isFormInValid = Object.values(person).some((value) => value === "");
    if (inputPassword === "") {
      setFieldErrors((prevErrors) => ({
        ...prevErrors,
        password: true,
      }));
    }
    if (isFormInValid || inputPassword === "") {
      setIsAddUserButtonDisabled(true);
      return false;
    } else {
      setIsAddUserButtonDisabled(false);
      return true;
    }
  }

  const [fieldErrors, setFieldErrors] = useState({
    firstName: false,
    lastName: false,
    username: false,
    userType: false,
    uniqueEmail: false,
    password: false,
  });

  const contactMethods = person.contactMethods || [];
  let phoneMethods = contactMethods.filter(
    (method) => method.contactType !== 4,
  );
  let emailMethods = contactMethods.filter(
    (method) => method.contactType === 4,
  );
  const [validEmailEntered, setValidEmailEntered] = useState(false);

  let customGroups = person.customGroups || [{ group_id: "" }];
  let groupOptions =
    useSelector((store) => actions.groups.loadGroupOptions()) || [];
  let [validUsername, setValidUsername] = useState(null);
  let [validUniqueEmail, setValidUniqueEmail] = useState(null);
  let [uniqueEmailError, setUniqueEmailError] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [userName, setUserName] = useState("");
  const [inputEmailValue, setInputEmailValue] = useState("");
  const [uniqueEmail, setUniqueEmail] = useState("");
  const [timer, setTimer] = useState(null);
  const [inputPassword, setInputPassword] = useState("");
  const [isButtonDisabled, setButtonDisable] = useState(false);

  let states = USStates;

  const [photoPreview, setPhotoPreview] = useState(null);
  const [photoFile, setPhotoFile] = useState(null);
  const handlePhotoChange = (file) => {
    if (file) {
      setPhotoFile(file);
      setPhotoPreview(URL.createObjectURL(file));
    }
  };

  function updateContact(index, name, value) {
    let updatedContactMethods = [...contactMethods];
    let updatedMethod = { ...updatedContactMethods[index], [name]: value };

    updatedContactMethods[index] = updatedMethod;

    if (name === "phone") {
      if (!value.includes("@") || value === "") {
        setValidEmailEntered(false);
      } else {
        setValidEmailEntered(true);
      }
    }
    updatePerson("contactMethods", updatedContactMethods);
  }

  function addGroup() {
    let groups = [...customGroups, { group_id: "" }];
    updatePerson("customGroups", groups);
  }

  function updateGroup(index, value) {
    let groups = [...customGroups];
    groups[index] = { group_id: value };
    updatePerson("customGroups", groups);
  }

  function removeGroup(index) {
    let groups = customGroups.filter((x, i) => i !== index);
    updatePerson("customGroups", groups);
  }

  useEffect(() => {
    updatePerson((prevPerson) => ({ ...prevPerson, contactMethods }));
  }, [contactMethods]);

  function handleConfirmModal() {
    if (!validateForm()) {
      return;
    } else {
      updateState({ showConfirmAddUser: true });
    }
  }
  async function savePerson() {
    const filteredContacts = (person.contactMethods || []).filter(
      (cm) => cm.phone && cm.phone.trim() !== "",
    );
    person = {
      ...person,
      contactMethods: filteredContacts,
      userName: userName,
      primaryEmail: uniqueEmail,
      password: inputPassword,
    };
    updateState("saving", true);
    let result = await actions.people.savePerson(person);
    if (result && result?.success) {
      if (photoFile && result.userId) {
        const token = appState().user.token;
        await api.user.uploadProfilePhotoForSpecificUser(
          token,
          photoFile,
          result.userId,
        );
      }
      showToast("success", "Person Added Successfully");
      navigate(Path.People);
    } else {
      updateState({ showConfirmAddUser: false });
      updateState("saving", false);
    }
  }

  const handleUsernameChange = (name, value) => {
    setInputValue(value);

    setFieldErrors((prevErrors) => ({
      ...prevErrors,
      [name]: value === "" ? true : false,
    }));

    clearTimeout(timer);

    if (value === "") {
      setValidUsername(null);
      setButtonDisable(true);
    } else {
      // Clear error immediately when user types something
      setFieldErrors((prevErrors) => ({
        ...prevErrors,
        username: false,
      }));
    }
  };

  useEffect(() => {
    if (inputValue !== "") {
      setTimer(
        setTimeout(() => {
          validateUser(inputValue);
        }, 1000),
      );
    }
    if (inputEmailValue !== "") {
      setTimer(
        setTimeout(() => {
          validateUniqueEmail(inputEmailValue);
        }, 1000),
      );
    }
  }, [inputValue, inputEmailValue]);

  async function validateUser(username) {
    const result = await actions.people.validateUsername(username, false);
    const isValid = result?.success === true;
    setValidUsername(isValid);

    if (isValid) {
      person = { ...person, username: inputValue };
      setUserName(inputValue);
      setButtonDisable(false);
      // Clear error when username is valid
      setFieldErrors((prev) => ({ ...prev, username: false }));
      return;
    }

    // On failure
    setFieldErrors((prev) => ({ ...prev, username: true }));
    setButtonDisable(true);
  }

  const handleUniqueEmailChange = (name, value) => {
    setFieldErrors((prevErrors) => ({
      ...prevErrors,
      [name]: value === "" ? true : false,
    }));

    clearTimeout(timer);
    setInputEmailValue(value);

    if (value === "") {
      setValidUniqueEmail(null);
      setFieldErrors((prevErrors) => ({
        ...prevErrors,
        uniqueEmail: true,
      }));
      setButtonDisable(true);
    }
  };
  async function validateUniqueEmail(uniqueEmail) {
    const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(uniqueEmail);
    if (isValidEmail) {
      person = { ...person, uniqueEmail: inputEmailValue };
      setUniqueEmail(inputEmailValue);
      setUniqueEmailError("");
      setButtonDisable(false);
      return;
    }

    // On failure
    setFieldErrors((prev) => ({ ...prev, uniqueEmail: true }));
    setUniqueEmailError("Add valid email");
    setButtonDisable(true);
  }
  const handlePasswordChange = (name, value) => {
    setInputPassword(value);

    setFieldErrors((prevErrors) => ({
      ...prevErrors,
      password: value === "" ? true : false,
    }));
  };
  const handleChange = (name, value) => {
    // Update the person object and set or remove alerts if value is empty or not for specific field.
    person = { ...person, username: inputValue, uniqueEmail: inputEmailValue };
    updatePerson(name, value);
    setFieldErrors((prevErrors) => ({
      ...prevErrors,
      [name]: value === "" ? true : false,
    }));
  };
  useEffect(() => {
    person = { ...person, username: inputValue, uniqueEmail: inputEmailValue };
    switch (true) {
      case person.firstName !== "":
      case person.lastName !== "":
      case person.userType !== "":
      case uniqueEmail !== "":
      case person.username !== "":
        validateFieldError();
        break;

      default:
        // No action needed if none of the fields are non-empty
        break;
    }
  }, [fieldErrors]);

  async function validateFieldError() {
    const hasErrors = Object.values(fieldErrors).some(
      (value) => value === true,
    );
    hasErrors ? setButtonDisable(true) : setButtonDisable(false);
  }
  const handleKeyDown = (e) => {};

  let cellPhones = phoneMethods.filter((m) => m.contactType === 3);
  let homePhones = phoneMethods.filter((m) => m.contactType === 1);
  let workPhones = phoneMethods.filter((m) => m.contactType === 2);
  return (
    <PageLayout title="Add User" className="add-person">
      <div className="ap-cards">
        {/* Card 1: User Information */}
        <div className="ap-card">
          <div className="ap-section-header desktop-only">
            <i className="fas fa-user ap-section-icon" />
            <span className="ap-section-title">User Information</span>
          </div>
          <span className="ap-required desktop-only">*Required</span>
          <div className="ap-user-info-body">
            <div className="ap-user-fields">
              <div className="ap-mobile-user-header mobile-only">
                <div className="ap-section-header">
                  <i className="fas fa-user ap-section-icon" />
                  <span className="ap-section-title">User Information</span>
                </div>
                <span className="ap-required">*Required</span>
              </div>
              {/* Row 1: First Name | Last Name */}
              <GuiTextbox
                label="First Name*"
                name="firstName"
                value={person?.firstName}
                onChange={(name, value) => handleChange(name, value)}
                maxLength={100}
                error={
                  fieldErrors.firstName && (
                    <span>
                      <i className="fas fa-exclamation-circle" /> Required Field
                    </span>
                  )
                }
              />
              <GuiTextbox
                label="Last Name*"
                name="lastName"
                value={person?.lastName}
                onChange={(name, value) => handleChange(name, value)}
                maxLength={100}
                error={
                  fieldErrors.lastName && (
                    <span>
                      <i className="fas fa-exclamation-circle" /> Required Field
                    </span>
                  )
                }
              />
              {/* Row 2: User Type | Primary Email */}
              <GuiSelect
                label="User Type*"
                name="userType"
                value={person?.userType}
                onChange={(name, option) => handleChange(name, option.value)}
                options={userTypeOptions}
                onkeydown={(e) => handleKeyDown(e)}
                error={
                  fieldErrors.userType && (
                    <span>
                      <i className="fas fa-exclamation-circle" /> Required Field
                    </span>
                  )
                }
              />
              <GuiTextbox
                label="Primary Email Address*"
                name="uniqueEmail"
                value={inputEmailValue}
                onChange={handleUniqueEmailChange}
                maxLength={100}
                error={
                  (fieldErrors?.uniqueEmail || uniqueEmailError) && (
                    <span>
                      <i className="fas fa-exclamation-circle" />{" "}
                      {uniqueEmailError || "Required Field"}
                    </span>
                  )
                }
              />
              {/* Row 3: Username | Password */}
              <div>
                {/* Hidden field absorbs browser credential autofill for username */}
                <input
                  type="text"
                  name="username"
                  style={{ display: "none" }}
                  readOnly
                  autoComplete="username"
                />
                <GuiTextbox
                  label="User Name*"
                  name="new-user-name"
                  value={inputValue}
                  autoComplete="off"
                  onChange={handleUsernameChange}
                  maxLength={50}
                  error={
                    fieldErrors?.username &&
                    inputValue === "" && (
                      <span>
                        <i className="fas fa-exclamation-circle" /> Required
                        Field
                      </span>
                    )
                  }
                />
                <div className="ap-validate-row">
                  {validUsername === true && (
                    <span className="valid-username">Valid Username!</span>
                  )}
                  {validUsername === false && (
                    <span className="username-exists">
                      Username already exists!
                    </span>
                  )}
                  <span className="ap-field-hint">
                    Username must be unique.
                  </span>
                </div>
              </div>
              <GuiTextbox
                label="Password*"
                name="password"
                type="password"
                value={inputPassword}
                maxLength={50}
                onChange={handlePasswordChange}
                autoComplete="new-password"
                error={
                  fieldErrors?.password && (
                    <span>
                      <i className="fas fa-exclamation-circle" /> Required Field
                    </span>
                  )
                }
              />
            </div>
            {/* Col 3: Profile Photo (spans all rows) */}
            <div className="ap-photo-section">
              <span className="ap-photo-title">Profile Photo</span>
              <div className="ap-photo-placeholder">
                <div className="ap-photo-bg-curve" />
                <div className="ap-photo-image-container">
                  {!photoPreview && (
                    <div className="ap-photo-initials">
                      <i className="fas fa-user" />
                    </div>
                  )}
                  {photoPreview && (
                    <img
                      src={photoPreview}
                      className="ap-photo-img"
                      alt="Profile"
                    />
                  )}
                </div>
              </div>
              <FileUploadButton
                name="profilePhoto"
                onChange={handlePhotoChange}
                acceptedTypes=".jpg, .jpeg, .png"
                maxFileSizeMB={5}
                isUploadBtn="true"
              />
            </div>
          </div>
        </div>

        {/* Card 2: Contact Information */}
        <div className="ap-card">
          <div className="ap-section-header">
            <i className="fas fa-message-check ap-section-icon" />
            <span className="ap-section-title">Contact Information</span>
          </div>
          <hr className="ap-divider" />

          {/* Email */}
          <div className="ap-contact-row">
            <div className="ap-contact-field">
              <GuiTextbox
                label="Email"
                maxLength={100}
                name="phone"
                value={emailMethods[0]?.phone || ""}
                onChange={(name, value) => {
                  const idx = contactMethods.findIndex(
                    (m) => m === emailMethods[0],
                  );
                  if (idx >= 0) updateContact(idx, name, value);
                }}
              />
            </div>
          </div>

          {/* Cell Phone */}
          <div className="ap-contact-row">
            <div className="ap-contact-field">
              <GuiTextbox
                label="Cell Phone"
                name="phone"
                value={cellPhones[0]?.phone || ""}
                maxLength={15}
                onChange={(name, value) => {
                  const idx = contactMethods.findIndex(
                    (m) => m === cellPhones[0],
                  );
                  if (idx >= 0) updateContact(idx, name, value);
                }}
              />
              <span className="ap-field-hint">
                This phone number should be able to receive texts
              </span>
            </div>
          </div>

          {/* Home Phone */}
          <div className="ap-contact-row">
            <div className="ap-contact-field">
              <div className="ap-phone-row">
                <GuiTextbox
                  label="Home Phone"
                  name="phone"
                  value={homePhones[0]?.phone || ""}
                  maxLength={15}
                  onChange={(name, value) => {
                    const idx = contactMethods.findIndex(
                      (m) => m === homePhones[0],
                    );
                    if (idx >= 0) updateContact(idx, name, value);
                  }}
                />
                <GuiTextbox
                  className="ap-ext-input"
                  label="Ext"
                  name="ext"
                  maxLength={5}
                  value={homePhones[0]?.ext || ""}
                  onChange={(name, value) => {
                    const idx = contactMethods.findIndex(
                      (m) => m === homePhones[0],
                    );
                    if (idx >= 0) updateContact(idx, name, value);
                  }}
                />
              </div>
            </div>
          </div>

          {/* Work Phone */}
          <div className="ap-contact-row">
            <div className="ap-contact-field">
              <div className="ap-phone-row">
                <GuiTextbox
                  label="Work Phone"
                  name="phone"
                  value={workPhones[0]?.phone || ""}
                  maxLength={15}
                  onChange={(name, value) => {
                    const idx = contactMethods.findIndex(
                      (m) => m === workPhones[0],
                    );
                    if (idx >= 0) updateContact(idx, name, value);
                  }}
                />
                <GuiTextbox
                  className="ap-ext-input"
                  label="Ext"
                  name="ext"
                  maxLength={5}
                  value={workPhones[0]?.ext || ""}
                  onChange={(name, value) => {
                    const idx = contactMethods.findIndex(
                      (m) => m === workPhones[0],
                    );
                    if (idx >= 0) updateContact(idx, name, value);
                  }}
                />
              </div>
            </div>
          </div>

          {/* Address */}
          <div className="ap-full-row">
            <GuiTextbox
              label="Address"
              name="address"
              maxLength={500}
              value={person.address || ""}
              onChange={updatePerson}
            />
          </div>
          <div className="ap-form-row">
            <GuiTextbox
              label="City"
              name="city"
              maxLength={100}
              value={person?.city || ""}
              onChange={updatePerson}
            />
            <GuiSelect
              label="State"
              name="state"
              value={person?.state}
              onChange={(name, option) => updatePerson(name, option.value)}
              onkeydown={(e) => handleKeyDown(e)}
              options={states}
            />
            <GuiTextbox
              label="Zip"
              name="zip"
              maxLength={10}
              value={person?.zip || ""}
              onChange={updatePerson}
            />
          </div>
        </div>

        {/* Card 3: Group Information */}
        <div className="ap-card">
          <div className="ap-section-header">
            <i className="fas fa-users ap-section-icon" />
            <span className="ap-section-title">Group Information</span>
          </div>
          <hr className="ap-divider" />
          {customGroups.map((id, i) => (
            <CustomGroup
              key={i}
              groupOptions={groupOptions}
              groupIds={customGroups}
              updateGroup={updateGroup}
              removeGroup={removeGroup}
              index={i}
              handleKeyDown={handleKeyDown}
            />
          ))}
          <hr className="ap-divider" />
          <GuiButton
            className="btn-outline ap-group-add-btn"
            onClick={addGroup}
          >
            <Icon icon="plus" weight="400" /> Add
          </GuiButton>
        </div>
      </div>

      {/* Footer */}
      <div className="ap-footer">
        <GuiButton
          className="btn-outline"
          onClick={() => navigate(Path.People)}
        >
          Cancel
        </GuiButton>
        <GuiButton
          className="ap-save-btn"
          onClick={handleConfirmModal}
          disabled={
            isAddUserButtonDisabled ||
            isButtonDisabled ||
            emailErrorFlags.some(Boolean) ||
            phoneErrorFlags.some(Boolean)
          }
        >
          Save
        </GuiButton>
      </div>

      {state.showConfirmAddUser && (
        <Modal
          className="modal confirm-user-modal"
          showModal={state.showConfirmAddUser}
          onClose={() => updateState({ showConfirmAddUser: false })}
        >
          <div className="confirm-user-modal-header">
            <span>Confirm Add User</span>
            <div onClick={() => updateState({ showConfirmAddUser: false })}>
              <i className="fa fa-close close-primary-icon cursor-pointer" />
            </div>
          </div>
          <div className="modal-footer-hr-divider" />
          <div className="confirm-user-modal-content">
            <span>
              After you select "Add User", the user account will be created. The
              user can log in using the username and password you provided.
            </span>
          </div>
          <div className="confirm-user-modal-footer">
            <GuiButton
              className="btn-outline"
              onClick={() => updateState({ showConfirmAddUser: false })}
            >
              Cancel
            </GuiButton>
            <GuiButton onClick={savePerson} className="primary-add-user">
              Add User
            </GuiButton>
          </div>
        </Modal>
      )}
    </PageLayout>
  );
}

function CustomGroup({
  groupIds,
  updateGroup,
  removeGroup,
  index,
  groupOptions,
  handleKeyDown,
}) {
  let groupId = groupIds[index].group_id;
  groupOptions = groupOptions.filter(
    (g) => g.value === groupId || !groupIds.includes(g.value),
  );

  return (
    <div className="ap-contact-row">
      <div className="custom-group">
        <p className="ap-group-label">Group {index + 1}</p>
        <div className="ap-group-row">
          <GuiSelect
            label=""
            name="group"
            value={groupId}
            onChange={(name, option) => updateGroup(index, option.value)}
            options={groupOptions}
            onkeydown={(e) => handleKeyDown(e)}
          />
          <Icon icon="xmark-large" onClick={() => removeGroup(index)} />
        </div>
      </div>
    </div>
  );
}
